import {
  Box,
  Button,
  createStyles,
  DialogActions,
  DialogContentText,
  DialogTitle,
  makeStyles,
  Theme,
  Typography,
  Dialog,
  IconButton,
} from '@material-ui/core';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { Dispute, PaymentRequest, DisputeStatus } from '../gql-types.generated';
import DisputeInformation from './DisputeInformation';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modalTitle: {
      padding: theme.spacing(2, 0),
    },
    modalTitleText: {
      fontWeight: 500,
    },
    dialogContextTitle: {
      color: 'black',
      marginBottom: 0,
    },
    dialogContent: {
      padding: 0,
    },
    dataGridItem: {
      padding: '10px !important',
    },
    dataLabel: {
      color: 'grey',
    },
    dataValue: {
      color: 'black',
    },
    infoSections: {
      margin: 0,
      padding: theme.spacing(1.5, 3),
    },
    sectionTitles: {
      fontWeight: 'bold',
      marginBottom: theme.spacing(1),
    },
    buttonHouse: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: theme.spacing(3),
    },
    middleButton: {
      marginRight: theme.spacing(2),
    },
    dividingLine: {
      height: '1px',
      width: '90%',
      margin: 'auto',
      backgroundColor: 'rgba(224, 224, 224, 1)',
      marginTop: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: 12,
      color: theme.palette.grey[500],
    },
  }),
);
interface ChargebackReviewProps {
  open: boolean;
  disputedRecord: Dispute;
  relatedPayment: PaymentRequest | null | undefined;
  onClose: () => void;
  concede: () => void;
}
const ChargebackReview: React.FC<ChargebackReviewProps> = props => {
  const classes = useStyles();
  const { disputedRecord, relatedPayment, onClose, concede, open } = props;
  const calculateDaysLeft = (createdAt: string) => {
    const dueDate = new Date(createdAt);
    const today = new Date();
    const difference = today.valueOf() - dueDate.valueOf();
    if (difference < 0) {
      return '0 days';
    }
    const days = Math.floor(difference / 86400000);
    if (days > 7) {
      return 'no days';
    }
    const remaining = 7 - days;
    return remaining === 1 ? '1 day' : `${remaining} days`;
  };
  const canChallenge = (createdAt: string) => {
    const dueDate = new Date(createdAt);
    const today = new Date();
    const difference = today.valueOf() - dueDate.valueOf();
    if (difference < 0) {
      return true;
    }
    const days = Math.floor(difference / 86400000);
    return days > 7;
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      disableBackdropClick={false}
      disableEscapeKeyDown={false}
      fullWidth={true}
      maxWidth={'md'}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box data-cy="chargeback-review">
        <Box className={classes.infoSections}>
          <DialogTitle disableTypography className={classes.modalTitle}>
            <Typography className={classes.modalTitleText} variant="h5" id="modal-title">
              A Payer Has Filed a Dispute
            </Typography>
            <IconButton aria-label="close" title="close" className={classes.closeButton} onClick={onClose} data-cy="close-dispute">
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContentText className={classes.dialogContextTitle} id="modal-description">
            Please review the following information and decide to challenge or concede. You have{' '}
            <strong>{calculateDaysLeft(disputedRecord.createdAt)} remaining</strong> to challenge the dispute.
          </DialogContentText>
        </Box>
        <DisputeInformation disputedRecord={disputedRecord} disputeState={'DISPUTED'} relatedPayment={relatedPayment} />
        <div className={classes.dividingLine}></div>
        <DialogActions className={classes.buttonHouse}>
          <Button
            disabled={disputedRecord.status === DisputeStatus.ConcededAwaitingPayfac}
            onClick={concede}
            variant="contained"
            color="primary"
            className={classes.middleButton}
            aria-label="Concede dispute"
            data-cy="concede"
          >
            Concede
          </Button>
          <Button
            disabled={disputedRecord.status === DisputeStatus.ChallengeAwaitingPayfac || canChallenge(disputedRecord.createdAt)}
            component={NavLink}
            to="/challenge-dispute"
            variant="contained"
            color="primary"
            aria-label="Challenge dispute"
            data-cy="challenge"
          >
            Challenge
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};
export default ChargebackReview;
